<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
// import { VueContentLoading } from "vue-content-loading";
import { mapActions, mapGetters } from "vuex";
//  import Ststistic from '../../../model/ststistic.js';

export default {
  page: {
    title: "الاحصائيات",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: "احصائيات عامة",
      items: [
        {
          text: "الرئيسية",
          href: "/",
        },
        {
          text: "الاحصائيات",
          active: true,
        },
      ],

      //Page errors.
      errors: [],

      showAdminStstistic: false,
      showLandStstistic: false,
      showLoanStstistic: false,
      showPilgrimageStstistic: false,
      showScholarshipsStstistic: false,
      showBoothsStstistic: false,
      showHousingunitsStstistic: false,
      showGovernmentLoansStstistic: false,
      showStstistic: false,

      ststistic: { services: { housingunits: {} } }, //new Ststistic,
      loadingContent: false,
    };
  },
  computed: {
    ...mapGetters("auth", ["getUser"]),
    ...mapGetters("ststistic", ["getStstistic"]),
  },
  methods: {
    ...mapActions("auth", ["hasAllPermission"]),
    ...mapActions("ststistic", ["getAll"]),
    handleError(error) {
      if (error.response.status == 422)
        this.errors = Object.values(error.response.data.errors);
      else
        this.errors = [
          `Error Code : ${error.response.status}  Message : ${error.response.data.message}`,
        ];
    },
  },
  created() {
    this.showBoothsStstistic = this.getUser.hasPermission("show_booths_ststistic");
    this.showAdminStstistic = this.getUser.hasPermission("show_admin_ststistic");
    this.showLandStstistic = this.getUser.hasPermission("show_land_ststistic");
    this.showLoanStstistic = this.getUser.hasPermission("show_loan_ststistic");
    this.showPilgrimageStstistic = this.getUser.hasPermission(
      "show_pilgrimage_ststistic"
    );
    this.showScholarshipsStstistic = this.getUser.hasPermission(
      "show_scholarships_ststistic"
    );
    this.showHousingunitsStstistic = this.getUser.hasPermission(
      "show_housingunits_ststistic"
    );
    this.showGovernmentLoansStstistic = this.getUser.hasPermission(
      "show_government_loans_ststistic"
    );

alert('showLoanStstistic = ')
alert(this.showLoanStstistic)

    this.showStstistic =
      this.showAdminStstistic ||
      this.showLandStstistic ||
      this.showLoanStstistic ||
      this.showPilgrimageStstistic ||
      this.showScholarshipsStstistic ||
      this.showBoothsStstistic ||
      this.showHousingunitsStstistic ||
      this.showGovernmentLoansStstistic;

      alert('showLoanStstistic = ')
alert(this.showLoanStstistic)


    if (this.showStstistic)
      this.getAll().then(() => {
        this.ststistic = this.getStstistic;
        this.loadingContent = true;
      });
    else this.loadingContent = true;
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <!-- <div class="col-md-4 col-sm-6" v-if="showPostStstistic">
                <div class="card">
                  <div class="card-body">
                    <h4 class="card-title mb-4">الاخبار</h4>
                    
                    <apexchart
                      class="apex-charts"
                      dir="rtl"
                      height="303"
                      type="donut"
                      :series="ststistic.charts.post.series"
                      :options="ststistic.charts.post.chartOptions"
                    ></apexchart>
                    
                    <div class="text-center text-muted">
                      <div class="row">
                        <div class="col-4" v-for="(item, i) in ststistic.charts.post.list.labels" :key="item">
                          <div class="mt-2">
                            <p class="mb-1 text-truncate">
                              <i :class="'mdi mdi-circle text-'+ststistic.charts.post.list.colors[i]+' mr-1'"></i>
                              {{item}}
                            </p>
                            <h5>{{ ststistic.charts.post.list.count[i] }}</h5>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div> -->
      <!-- <div class="col-md-4 col-sm-6" v-if="showImageStstistic">
                <div class="card">
                  <div class="card-body">
                    <h4 class="card-title mb-4">البوم الصور</h4>
              
                    <apexchart
                      class="apex-charts"
                      height="303"
                      type="pie"
                      dir="ltr"
                      :series="ststistic.charts.image.series"
                      :options="ststistic.charts.image.chartOptions"
                    ></apexchart>

                    <div class="text-center text-muted">
                      <div class="row">
                        <div class="col-3" v-for="(item, i) in ststistic.charts.image.list.labels" :key="item">
                          <div class="mt-2">
                            <p class="mb-1 text-truncate">
                              <i :class="'mdi mdi-circle text-'+ststistic.charts.image.list.colors[i]+' mr-1'"></i>
                              {{item}} 
                            </p>
                            <h5>{{ ststistic.charts.image.list.count[i] }}</h5>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div> -->
      <!-- <div class="col-md-6" >
                <div class="card mini-stats-wid">
                  <div class="card-body">
                    <div class="d-flex flex-wrap">
                      <div class="mr-3">
                        <p class="text-muted mb-2">عدد المستندات</p>
                        <h5 class="mb-0">{{ststistic.attachments}}</h5>
                      </div>
                      <div class="avatar-sm ms-auto">
                        <div class="avatar-title bg-light rounded-circle text-primary font-size-20">
                          <i class="bx bxs-file-doc"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div> -->

      <div class="col-md-4">
        <div class="card mini-stats-wid">
          <div class="card-body">
            <div class="d-flex flex-wrap">
              <div class="mr-3">
                <p class="text-muted mb-2">عدد الخدمات</p>
                <h5>10</h5>
              </div>
              <div class="avatar-sm ms-auto">
                <div
                  class="avatar-title bg-light rounded-circle text-primary font-size-20"
                >
                  <i class="bx bx-shape-circle"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="card mini-stats-wid">
          <div class="card-body">
            <div class="d-flex flex-wrap">
              <div class="mr-3">
                <p class="text-muted mb-2">عدد المستخدمين</p>
                <h5>{{ ststistic.services.all }}</h5>
              </div>
              <div class="avatar-sm ms-auto">
                <div
                  class="avatar-title bg-light rounded-circle text-primary font-size-20"
                >
                  <i class="fa fa-users"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="card mini-stats-wid">
          <div class="card-body">
            <div class="d-flex flex-wrap">
              <div class="mr-3">
                <p class="text-muted mb-2">عدد المدراء</p>
                <h5>{{ ststistic.admins }}</h5>
              </div>
              <div class="avatar-sm ms-auto">
                <div
                  class="avatar-title bg-light rounded-circle text-primary font-size-20"
                >
                  <i class="bx bxs-user-detail"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">الخدمات المقدمة</h4>
            <p class="card-title-desc">عدد المستفيدين من الخدمات المقدمة في المنصة</p>

            <div class="table-responsive">
              <table class="table table-sm table-striped m-0">
                <thead>
                  <tr>
                    <th>-</th>
                    <th>الخدمة</th>
                    <th>عدد المستفيدين</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="showLoanStstistic">
                    <th>-</th>
                    <td>استمارة القروض (الجرحى)</td>
                    <td>{{ ststistic.services.loan.woundeds }}</td>
                  </tr>
                  <tr v-if="showLoanStstistic">
                    <th>-</th>
                    <td>استمارة القروض (الشهداء)</td>
                    <td>{{ ststistic.services.loan.martyrs }}</td>
                  </tr>
                  <tr v-if="showLandStstistic">
                    <th>-</th>
                    <td>استمارة الاراضي (الجرحى)</td>
                    <td>{{ ststistic.services.land.woundeds }}</td>
                  </tr>
                  <tr v-if="showLandStstistic">
                    <th>-</th>
                    <td>استمارة الاراضي (الشهداء)</td>
                    <td>{{ ststistic.services.land.martyrs }}</td>
                  </tr>
                  <tr v-if="showPilgrimageStstistic">
                    <th>-</th>
                    <td>استمارة الحــج</td>
                    <td>{{ ststistic.services.pilgrimage.all }}</td>
                  </tr>
                  <tr v-if="showBoothsStstistic && ststistic.services.booths">
                    <th>-</th>
                    <td>استمارة حجز بوث</td>
                    <td>{{ ststistic.services.booths.all }}</td>
                  </tr>
                  <tr v-if="showScholarshipsStstistic">
                    <th>-</th>
                    <td>استمارة المنح الدراسية</td>
                    <td>{{ ststistic.services.scholarships.all }}</td>
                  </tr>
                  <tr v-if="showHousingunitsStstistic">
                    <th>-</th>
                    <td>استمارة الوحدات السكنية (الجرحى)</td>
                    <td>{{ ststistic.services.housingunits.woundeds }}</td>
                  </tr>
                  <tr v-if="showHousingunitsStstistic">
                    <th>-</th>
                    <td>استمارة الوحدات السكنية (الشهداء)</td>
                    <td>{{ ststistic.services.housingunits.martyrs }}</td>
                  </tr>
                  <tr v-if="showHousingunitsStstistic">
                    <th>-</th>
                    <td>استمارة الوحدات السكنية (المنتسبين)</td>
                    <td>{{ ststistic.services.housingunits.employees }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- </div> -->
    <!-- <div v-else>
        <h1>This index Page</h1>
      </div> -->

    <!-- </div> -->

    <!-- loading content -->
    <!-- <div v-else>
      <vue-content-loading :rtl="true" :width="400" :height="110">
        <rect x="0" y="0" rx="1" ry="1" width="129" height="100" />
        <rect x="136" y="0" rx="1" ry="1" width="129" height="100" />
        <rect x="272" y="0" rx="1" ry="1" width="129" height="22" />
        <rect x="272" y="26" rx="1" ry="1" width="129" height="22" />
        <rect x="272" y="52" rx="1" ry="1" width="129" height="22" />
        <rect x="272" y="78" rx="1" ry="1" width="129" height="22" />
      </vue-content-loading>
    </div> -->
  </Layout>
</template>
